import { FC } from 'react'

import { Icon, Link } from '..'

type LinkBackProps = {
  link: string,
  text?: string
}

const LinkBack:FC<LinkBackProps> = ({ link = '', text = 'Regresar' }) => {
  return (
    <Link to={link}>
      <Icon name="arrow-left" size={13} className="mr-5" />{text}
    </Link>
  )
}

export { LinkBack }